var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.showDetail
    ? _c(
        "div",
        {
          staticStyle: {
            height: "100%",
            display: "flex",
            "flex-direction": "column"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "cargo-advance-search profit-share-config",
              staticStyle: {
                width: "100%",
                "margin-top": "5px",
                "min-width": "1280px"
              }
            },
            [
              _c(
                "div",
                { staticClass: "section" },
                [
                  _c(
                    "el-form",
                    {
                      attrs: { "label-position": "left", "label-width": "85px" }
                    },
                    [
                      _c(
                        "el-row",
                        {
                          staticStyle: { "margin-bottom": "5px" },
                          attrs: { gutter: 10 }
                        },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary", no: "query" },
                                  on: { click: _vm.toQuery }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("CargoMsg.Cargo_Query")) +
                                      " "
                                  )
                                ]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary", no: "createRule" },
                                  on: { click: _vm.toCreate }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("CargoMsg.Cargo_CreateRule")
                                      ) +
                                      " "
                                  )
                                ]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary", no: "editRule" },
                                  on: { click: _vm.toEdit }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("CargoMsg.Cargo_EditRule")
                                      ) +
                                      " "
                                  )
                                ]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary", no: "copyRule" },
                                  on: { click: _vm.toCopy }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("CargoMsg.Cargo_CopyRule")
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          ),
          _c("div", { staticClass: "grid-view" }, [
            _c("div", { staticClass: "main-content" }, [
              _c(
                "div",
                { staticClass: "section grid-wrapper" },
                [
                  _c("cargo-ag-grid", {
                    attrs: {
                      "config-module": "261606",
                      "grid-params": _vm.gridParams,
                      "grid-options": _vm.gridOptions,
                      "column-defs": _vm.columnDefs,
                      "row-data": _vm.rowData
                    },
                    on: {
                      "update:gridParams": function($event) {
                        _vm.gridParams = $event
                      },
                      "update:grid-params": function($event) {
                        _vm.gridParams = $event
                      }
                    }
                  })
                ],
                1
              )
            ]),
            _c(
              "div",
              { staticClass: "pagination-wrapper" },
              [
                _c("cargo-pagination", {
                  attrs: {
                    "config-module": "261606",
                    total: _vm.filter.total,
                    page: _vm.filter.pageNum,
                    limit: _vm.filter.pageSize
                  },
                  on: {
                    "update:page": function($event) {
                      return _vm.$set(_vm.filter, "pageNum", $event)
                    },
                    "update:limit": function($event) {
                      return _vm.$set(_vm.filter, "pageSize", $event)
                    },
                    pagination: _vm.toQuery
                  }
                })
              ],
              1
            )
          ])
        ]
      )
    : _c(
        "div",
        {
          staticClass: "profit-share-config app-main-content",
          staticStyle: { height: "100%" }
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                height: "28px",
                "margin-left": "16px",
                "margin-top": "16px"
              }
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.onSave()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Save")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "default" },
                  on: {
                    click: function($event) {
                      return _vm.onCancel()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
              )
            ],
            1
          ),
          _c(
            "cargo-left-right-resize",
            {
              ref: "cargoLeftRightResize",
              staticStyle: {
                "min-height": "90%",
                border: "1px solid",
                margin: "16px"
              },
              attrs: {
                "left-style": {
                  flex: "none",
                  "max-width": "271px",
                  "min-width": "271px"
                }
              }
            },
            [
              _c("template", { slot: "left" }, [
                _c(
                  "div",
                  { staticClass: "tabs-container section" },
                  [
                    _c(
                      "el-tabs",
                      {
                        staticStyle: { width: "100%" },
                        attrs: { type: "card" },
                        on: { "tab-click": _vm.handleTabClick },
                        model: {
                          value: _vm.activeTab,
                          callback: function($$v) {
                            _vm.activeTab = $$v
                          },
                          expression: "activeTab"
                        }
                      },
                      [
                        _c(
                          "el-tab-pane",
                          {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_RuleConfig"),
                              name: "activity"
                            }
                          },
                          [
                            _c(
                              "el-form",
                              {
                                staticStyle: { margin: "10px" },
                                attrs: {
                                  "label-position": "top",
                                  "label-width": "200px"
                                }
                              },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("CargoMsg.Cargo_RuleName"),
                                      required: ""
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      model: {
                                        value: _vm.form.name,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "name", $$v)
                                        },
                                        expression: "form.name"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "CargoMsg.Cargo_SalesBranchCompany"
                                      ),
                                      required: ""
                                    }
                                  },
                                  [
                                    _c("cargo-advance-select", {
                                      attrs: {
                                        "select-type":
                                          _vm.selectTypeNames.basic_data_Office,
                                        multiple: "",
                                        clearable: "",
                                        filterable: "",
                                        "default-multiple-value":
                                          _vm.form.branchIds
                                      },
                                      on: {
                                        parentCallBack: function(p) {
                                          _vm.form.branchIds = p.value
                                        }
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    staticStyle: { height: "120px" },
                                    attrs: {
                                      label: _vm.$t("CargoMsg.Cargo_Remarks")
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: { type: "textarea" },
                                      model: {
                                        value: _vm.form.remark,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "remark", $$v)
                                        },
                                        expression: "form.remark"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-tab-pane",
                          {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_RuleRole"),
                              name: "node"
                            }
                          },
                          [
                            _c(
                              "el-form",
                              {
                                class:
                                  _vm.chooseIndex === null ? "no-click" : "",
                                staticStyle: { margin: "10px" },
                                attrs: {
                                  disabled: _vm.chooseIndex === null,
                                  "label-position": "top",
                                  "label-width": "200px"
                                }
                              },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("CargoMsg.Cargo_ShareMode"),
                                      required: ""
                                    }
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          no: "shareMode",
                                          clearable: false
                                        },
                                        model: {
                                          value: _vm.node.shareMode,
                                          callback: function($$v) {
                                            _vm.$set(_vm.node, "shareMode", $$v)
                                          },
                                          expression: "node.shareMode"
                                        }
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: {
                                            label: _vm.$t(
                                              "CargoMsg.Cargo_ShareModeJob"
                                            ),
                                            value: "job"
                                          }
                                        }),
                                        _c("el-option", {
                                          attrs: {
                                            label: _vm.$t(
                                              "CargoMsg.Cargo_ShareModeCurrency"
                                            ),
                                            value: "currency"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("CargoMsg.Cargo_UsdRatio"),
                                      required: ""
                                    }
                                  },
                                  [
                                    _c("el-input-number", {
                                      staticStyle: { width: "230px" },
                                      attrs: {
                                        no: "usdRatio",
                                        controls: false,
                                        min: 0,
                                        max: 100,
                                        precision: 0
                                      },
                                      model: {
                                        value: _vm.node.usdRatio,
                                        callback: function($$v) {
                                          _vm.$set(_vm.node, "usdRatio", $$v)
                                        },
                                        expression: "node.usdRatio"
                                      }
                                    }),
                                    _vm._v("% ")
                                  ],
                                  1
                                ),
                                _vm.showNonUsdRatioInput
                                  ? _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "CargoMsg.Cargo_NonUsdRatio"
                                          ),
                                          required: ""
                                        }
                                      },
                                      [
                                        _c("el-input-number", {
                                          staticStyle: { width: "230px" },
                                          attrs: {
                                            no: "nonUsdRatio",
                                            controls: false,
                                            min: 0,
                                            max: 100,
                                            precision: 0
                                          },
                                          model: {
                                            value: _vm.node.nonUsdRatio,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.node,
                                                "nonUsdRatio",
                                                $$v
                                              )
                                            },
                                            expression: "node.nonUsdRatio"
                                          }
                                        }),
                                        _vm._v("% ")
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _c("template", { slot: "right" }, [
                _c(
                  "div",
                  {
                    staticClass: "col",
                    staticStyle: {
                      width: "99%",
                      height: "96%",
                      overflow: "auto",
                      display: "flex",
                      "flex-direction": "column",
                      "background-color": "white",
                      margin: "12px 12px 12px 6px"
                    }
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { width: "100%", height: "100%" } },
                      [
                        _c(
                          "draggable",
                          {
                            staticStyle: { width: "100%" },
                            attrs: { disabled: "", animation: "300" },
                            on: { sort: _vm.sort },
                            model: {
                              value: _vm.form.subList,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "subList", $$v)
                              },
                              expression: "form.subList"
                            }
                          },
                          [
                            _c(
                              "transition-group",
                              { staticStyle: { width: "100%" } },
                              _vm._l(_vm.form.subList, function(
                                item,
                                workflowIndex
                              ) {
                                return _c(
                                  "div",
                                  { key: item.priority, staticClass: "item" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          width: "100%",
                                          height: "100%"
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              height: "36px",
                                              "background-color":
                                                "rgba(244, 249, 255)",
                                              display: "flex"
                                            }
                                          },
                                          [
                                            _c("img", {
                                              staticStyle: {
                                                "align-self": "center",
                                                "margin-left": "5px",
                                                width: "11px",
                                                height: "11px"
                                              },
                                              attrs: { src: "/static/move.svg" }
                                            }),
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  "align-self": "center",
                                                  "margin-left": "5px"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "CargoMsg.Cargo_Priority"
                                                    ) +
                                                      (workflowIndex + 1)
                                                  )
                                                )
                                              ]
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  "align-self": "center",
                                                  "margin-left": "40px",
                                                  color: "rgba(65, 141, 220)"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.onConfiguration(
                                                      workflowIndex
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "CargoMsg.Cargo_TriggerConditions"
                                                    ) +
                                                      ": " +
                                                      _vm.getTriggerConditionsLabel(
                                                        item.ruleMode
                                                      )
                                                  )
                                                )
                                              ]
                                            ),
                                            _c("i", {
                                              staticClass: "el-icon-delete",
                                              staticStyle: {
                                                "align-self": "center",
                                                color: "red",
                                                "margin-right": "10px"
                                              },
                                              on: {
                                                "!click": function($event) {
                                                  return _vm.removeBranch(
                                                    workflowIndex
                                                  )
                                                }
                                              }
                                            })
                                          ]
                                        ),
                                        _c(
                                          "draggable",
                                          {
                                            staticStyle: {
                                              display: "flex",
                                              "flex-wrap": "wrap",
                                              "padding-left": "28px",
                                              "margin-bottom": "15px"
                                            },
                                            attrs: {
                                              options: {
                                                handle: ".drag-handle"
                                              }
                                            },
                                            on: { end: _vm.toEnd },
                                            model: {
                                              value: item.subRoleList,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  item,
                                                  "subRoleList",
                                                  $$v
                                                )
                                              },
                                              expression: "item.subRoleList"
                                            }
                                          },
                                          _vm._l(item.subRoleList, function(
                                            card,
                                            index
                                          ) {
                                            return _c(
                                              "div",
                                              {
                                                key: index,
                                                staticStyle: {
                                                  display: "flex",
                                                  "flex-wrap": "wrap",
                                                  "align-self": "center",
                                                  "margin-top": "15px"
                                                }
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value:
                                                          item.multiRole ||
                                                          (!item.multiRole &&
                                                            index < 1),
                                                        expression:
                                                          "item.multiRole || (!item.multiRole && index < 1)"
                                                      }
                                                    ],
                                                    class:
                                                      "record-card " +
                                                      (item.priority ===
                                                        _vm.choosePriority &&
                                                      index === _vm.chooseIndex
                                                        ? "is-active"
                                                        : "") +
                                                      (card.isAdd
                                                        ? " no-drag"
                                                        : ""),
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.chooseNode(
                                                          card,
                                                          item.priority,
                                                          index
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    !card.isAdd
                                                      ? _c("div", [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticStyle: {
                                                                margin: "10px",
                                                                display: "flex"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "drag-handle",
                                                                  staticStyle: {
                                                                    "padding-right":
                                                                      "10px"
                                                                  }
                                                                },
                                                                [
                                                                  _c("i", {
                                                                    staticClass:
                                                                      "el-icon-rank",
                                                                    staticStyle: {
                                                                      "margin-right":
                                                                        "10px"
                                                                    }
                                                                  }),
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "node-name"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.showShareMode(
                                                                            card
                                                                          )
                                                                        )
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              ),
                                                              _c("i", {
                                                                staticClass:
                                                                  "el-icon-delete",
                                                                on: {
                                                                  "!click": function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.removeNode(
                                                                      workflowIndex,
                                                                      index
                                                                    )
                                                                  }
                                                                }
                                                              })
                                                            ]
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "card-content",
                                                              attrs: {
                                                                title: _vm.showUsdRatio(
                                                                  card
                                                                )
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm.showUsdRatio(
                                                                      card
                                                                    )
                                                                  ) +
                                                                  " "
                                                              )
                                                            ]
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "card-content",
                                                              staticStyle: {
                                                                "margin-top":
                                                                  "10px"
                                                              },
                                                              attrs: {
                                                                title: _vm.showNonUsdRatio(
                                                                  card
                                                                )
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm.showNonUsdRatio(
                                                                      card
                                                                    )
                                                                  ) +
                                                                  " "
                                                              )
                                                            ]
                                                          )
                                                        ])
                                                      : _c("div", [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticStyle: {
                                                                height: "100%",
                                                                "margin-top":
                                                                  "10%",
                                                                "text-align":
                                                                  "center"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticStyle: {
                                                                    cursor:
                                                                      "pointer",
                                                                    "font-size":
                                                                      "40px",
                                                                    color:
                                                                      "rgba(159, 180, 225)"
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      $event.stopPropagation()
                                                                      return _vm.addNode(
                                                                        workflowIndex,
                                                                        item.priority
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [_vm._v("+")]
                                                              )
                                                            ]
                                                          )
                                                        ])
                                                  ]
                                                ),
                                                index <
                                                item.subRoleList.length - 1
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticStyle: {
                                                          position: "relative"
                                                        }
                                                      },
                                                      [
                                                        _c("div", {
                                                          staticClass:
                                                            "arrow-container"
                                                        })
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          }),
                                          0
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                )
                              }),
                              0
                            )
                          ],
                          1
                        ),
                        _c(
                          "div",
                          [
                            _c(
                              "el-button",
                              {
                                staticStyle: {
                                  "background-color": "rgba(244, 249, 255)",
                                  "margin-left": "10px",
                                  "margin-top": "10px"
                                },
                                attrs: {
                                  disabled: !_vm.form.multiSub,
                                  type: "text"
                                },
                                on: { click: _vm.addBranchProcess }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("CargoMsg.Cargo_AddRuleConfigSub")
                                  )
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            2
          ),
          _vm.ruleConfigurationDialog.visible
            ? _c("rule-config-condition-dialog", {
                attrs: {
                  visible: _vm.ruleConfigurationDialog.visible,
                  rules: _vm.rules,
                  workflow: _vm.form.subList[_vm.chooseWorkflowIndexRule]
                },
                on: {
                  "update:visible": function($event) {
                    return _vm.$set(
                      _vm.ruleConfigurationDialog,
                      "visible",
                      $event
                    )
                  },
                  close: function($event) {
                    _vm.ruleConfigurationDialog.visible = false
                  },
                  change: function(p) {
                    _vm.form.subList[_vm.chooseWorkflowIndexRule] = p
                  }
                }
              })
            : _vm._e()
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }